import { makeStyles, createStyles } from '@material-ui/styles'

export const PolicyStyles = makeStyles((theme) =>
  createStyles({
    footerButtonContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    visitPolicyLibButton: {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      textAlign: 'center',

      width: '100%',
      height: '40px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    tabBackground: {
      overflowY: 'hidden',
      width: '100%',
      minHeight: 35,
      height: '35px',
    },
    modalTabs: {
      width: 335,
      height: 35,
      [theme.breakpoints.down(400)]: {
        width: 300,
      },
    },
    searchBarContainer: {
      margin: theme.spacing(0.5, 1),
    },
    tabPanelContainer: {
      width: '100%',
      overflowY: 'auto',
      height: 344,
      maxHeight: 344,
      borderBottom: `1px solid ${theme.palette.base.lightGray}`,
      [theme.breakpoints.down(769)]: {
        height: 'calc(100dvh - 330px)',
      },
    },
    announcementList: {
      width: '100%',
      padding: theme.spacing(0, 1),
    },
    gridItem: {
      width: '100%',
    },
    announcementCardBackground: {
      height: 'auto',
      width: '100%',
      margin: theme.spacing(1, 0),
    },
    announcementBody: {
      paddingRight: 10,
      paddingLeft: 10,
      paddingBottom: 10,
    },
    titleButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'top',
      paddingLeft: 10,
    },
    titleButton: {
      maxWidthwidth: '30%',
      height: '35px',
      color: 'white',
      borderTopLeftRadius: '0px',
      borderBottomRightRadius: '0px',
      background: theme.palette.base.red,
    },
    noItemFoundContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '20px',
    },
    noItemFoundText: {
      textAlign: 'center',
      marginTop: '10px',
    },
    descriptionText: {
      color: theme.palette.components.linkText,
      '& a': {
        textDecoration: 'underline',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
      },
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
      maxWidth: '100%',
      [theme.breakpoints.down(376)]: {
        fontSize: '0.75rem',
      },
    },
  }),
)

export default PolicyStyles
